import React from 'react';
import { useDocumentState } from '@src/hooks/documentState';

import LockIcon from '../../../assets/icons/lock.svg';
import LockSubIcon from '../../../assets/icons/sub-lock.svg';
import UnlockIcon from '../../../assets/icons/open-lock.svg';
import UnlockSubIcon from '../../../assets/icons/open-sub-lock.svg';

const DocumentIcons = ({ requiresSubscription, id }) => {
  const documentState = useDocumentState(requiresSubscription, id);

  return documentState === 'Open' ? (
    <img src={UnlockSubIcon} className="category-option-image lock-icon" alt="Unlock sub icon" />
  ) : (
    <>
      {documentState === 'Purchased' ? (
        <img src={UnlockIcon} className="category-option-image lock-icon" alt="Unlock icon" />
      ) : requiresSubscription ? (
        <img src={LockSubIcon} className="category-option-image lock-icon" alt="lock sub icon" />
      ) : (
        <img src={LockIcon} className="category-option-image lock-icon" alt="lock icon" />
      )}
    </>
  );
};

export default DocumentIcons;
